import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { TextGateway } from './text.gateway';
import { firstValueFrom } from 'rxjs';
import {
  DEFAULT_WEB_TEXTS,
  EEntityType,
  ERelationType,
  ETextType,
  INormalText,
} from '@web/dtos';
import { IApiResponse } from '@web/shared-types';

@Injectable({
  providedIn: 'root',
})
export class WebTextStore {
  private readonly gateway: TextGateway = new TextGateway();

  readonly #textResource: ResourceRef<IApiResponse<INormalText[]> | undefined> =
    resource({
      loader: (): Promise<IApiResponse<INormalText[]>> => {
        return firstValueFrom(this.gateway.get(ETextType.Web));
      },
    });

  readonly isLoading: Signal<boolean> = computed(() =>
    this.#textResource.isLoading()
  );
  readonly texts: Signal<INormalText[]> = computed((): INormalText[] =>
    this.#textResource.hasValue()
      ? (this.#textResource.value()?.data ?? DEFAULT_WEB_TEXTS)
      : DEFAULT_WEB_TEXTS
  );

  readonly buttonText: Signal<INormalText[]> = computed(() => {
    return this.texts().filter(
      (ticket: INormalText) =>
        ticket.entityType === EEntityType.ticketButton &&
        ticket.relationType === ERelationType.button
    );
  });

  updateNormalText(query: INormalText[]): void {
    this.#textResource.update((): IApiResponse<INormalText[]> => {
      return {
        data: query,
      };
    });
  }

  async save(query: INormalText[]): Promise<void> {
    const result: IApiResponse<INormalText[]> = await firstValueFrom(
      this.gateway.save(query)
    );
    if (result?.data) {
      this.updateNormalText(result.data);
    }
  }

  reload(): void {
    this.#textResource.reload();
  }
}
